<template>
  <div id="app" class="container">
    <template v-if="!$store.state.isHiddenContainer">
      <!-- 顶部 -->
      <div class="head">
        <div class="right">
          <img src="./assets/user_icon.png" class="userPic" />
          <p>{{username}}</p>
          <img src="./assets/logout.png" class="logoutPic" />
          <span @click="logout">注销登录</span>
        </div>
      </div>
      <!-- 左侧菜单 -->
      <div class="aside">
        <el-menu
          @select="selectItem"
          :default-active="defaultActive"
          background-color="#3a3f4a"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <template v-for="(router, index) in leftRouters">
            <el-submenu
              :index="router.name"
              v-if="router.children && router.children.length"
              :key="index"
            >
              <template slot="title">
                <i :class="router.icon"></i>
                <span>{{router.label}}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  v-for="(item, _index) in router.children"
                  :key="_index"
                  :index="item.name"
                  @click="clickItem"
                >
                  <template slot="title">
                    <i :class="item.icon"></i>
                    <span>{{item.label}}</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item :index="router.name" v-else @click="clickItem" :key="index">
              <i :class="router.icon"></i>
              <span>{{router.label}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </template>
    <router-view :key="activeDate" style="overflow-y: auto;" />
  </div>
</template>

<script>
import { clearUserInfo } from './utils/cache'
import { leftRouters } from './router'
export default {
  data () {
    return {
      leftRouters,
      activeDate: ''
    }
  },
  computed: {
    defaultActive () {
      return this.$store.state.defaultActive
    },
    username () {
      return this.$store.state.username
    }
  },
  methods: {
    selectItem (name) {
      let router = this.leftRouters.find(item => item.leftMenu === name)
      let path = '/'
      if (router) {
        path = router.path
      } else {
        this.leftRouters.forEach(item => {
          if (item.children) {
            router = item.children.find(_item => _item.leftMenu === name)
            if (router) {
              path = item.path + '/' + router.path
            }
          }
        })
      }
      if (this.$router.currentRoute.name !== name) {
        this.$router.push(path)
      }
    },
    // 点击左侧菜单刷新
    clickItem () {
      this.activeDate = new Date().toString()
    },
    logout () {
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearUserInfo()
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-family: "Microsoft Yahei", "Hiragino Sans GB", "Helvetica Neue",
    Helvetica, tahoma, arial, Verdana, sans-serif, "WenQuanYi Micro Hei", "宋体";
}
html,
body,
.container {
  .el-menu-item-group__title {
    padding: 0;
  }
  width: 100%;
  height: 100%;
  background-color: #fff;
  .head {
    position: fixed;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1000;
    width: 100%;
    height: 100px;
    background-image: url("./assets/topbar.png");
    background-size: cover;
    .right {
      position: absolute;
      right: 20px;
      display: flex;
      align-items: center;
      .userPic {
        width: 35px;
        border: 50%;
      }
      .logoutPic {
        margin-left: 40px;
        width: 18px;
      }
      p,
      span {
        margin-left: 5px;
        color: #fff;
      }
      span {
        cursor: pointer;
        margin-right: 30px;
      }
    }
  }
  .aside {
    margin-right: 10px;
    width: 220px !important;
    height: calc(100% - 110px);
    margin-top: 110px;
    background-color: #3a3f4a;
    border-top-right-radius: 8px;
    overflow-y: auto;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    overflow-x: hidden;
  }
  .el-menu {
    border: 0;
    .el-menu-item,
    .el-submenu__title {
      height: 60px;
      line-height: 60px;
    }
  }
  .el-menu-item.is-active {
    background-color: #2a2c2f !important;
  }
}
.main {
  position: relative;
  width: calc(100% - 230px);
  height: calc(100% - 110px);
  top: 110px;
  left: 230px;
  .color606266 {
    color: #606266;
  }
  .el-button {
    font-weight: normal;
  }
  .top {
    width: 99%;
    height: 50px;
    background: #f2f2f2;
    border-left: 7px solid #00b0f0;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    color: #333;
    position: relative;
    font-size: 18px;
    .title {
      margin-left: 20px;
      font-size: 18px;
      color: #00b0f0;
      font-weight: bold;
    }
    .goback {
      width: 30px;
      margin: 0 10px 0 15px;
    }
    .goback:hover {
      cursor: pointer;
    }
    .process {
      height: 60px;
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }
  .content {
    margin-left: 70px;
    padding-right: 150px;
    .heading {
      margin: 10px 0;
      i {
        font-size: 24px;
        color: #00aff0;
      }
      .caption {
        margin-left: 6px;
        font-size: 20px;
        color: #00b0f0;
        font-weight: bold;
      }
    }
  }
  .hoverContainer {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    .hoverDiv {
      font-size: 24px;
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      background-color: #00000080;
      transition: opacity 0.3s;
      .el-icon-delete:hover {
        cursor: pointer;
      }
    }
  }
  .picDiv {
    position: relative;
    width: 100px;
    height: 100px;
    margin-right: 5px;
    .width100 {
      width: 100px;
      height: 100px;
    }
  }
  .picDiv:hover .hoverContainer {
    display: block;
  }
  .dottedDiv {
    position: relative;
    border: 1px dotted #ccc;
    width: 100px;
    height: 100px;
    .fileInput {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100px;
      height: 100px;
    }
  }
  .hideDottedDiv {
    display: none;
  }
  .dottedDiv:hover {
    cursor: pointer;
  }
  .uploadPic {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .pictures {
    height: 100px;
  }
}
</style>
